import * as ReportingActions from "../actions/Reporting/Reporting.Actions";
import { IReportTreeNode, ReportType } from "@vmosolutions/oc-interfaces";

export const ROOT_PATH = "/";

export const initializeReportNode = (children: IReportTreeNode[]): IReportTreeNode => {
  return {
    _id: undefined,
    name: "Root",
    parentId: undefined,
    readonly: true,
    children: [],
    nodeType: ReportType.folder,
  };
};

export interface IReportingState {
  path: string;
  rootReportNode: IReportTreeNode;
  activeNode: IReportTreeNode | null;
}

const initialState: IReportingState = {
  path: ROOT_PATH,
  rootReportNode: initializeReportNode([]),
  activeNode: null,
};

export interface INodeParent {
  parentId: string;
  path: string;
}

/**
 * Find a specific node inside the ReportTreeNode and return it's parent's absolute path as a string.
 * This is just used to display the node's path to the user (uneditable field) to faciliate editing
 * @param _id - id of the node you're looking for
 * @param rootNode - node you're checking
 * @param path - recursive path.
 */
export const returnNodeParent = (_id: string, rootNode: IReportTreeNode, path?: string): INodeParent | null => {
  if (!rootNode || !_id) {
    return null;
  }

  const inputPath = path ?? "/";

  for (const node of rootNode.children) {
    if (node._id === _id) {
      const nodeParent = {
        parentId: rootNode?._id,
        path: inputPath,
      };
      //console.log("MATCH FOUND", nodeParent);
      return nodeParent;
    } else {
      // Keep recursively searching Tree.
      const deeperPath = inputPath + node.name + "/";
      const matchFound = returnNodeParent(_id, node, deeperPath);
      if (matchFound) {
        return matchFound;
      }
    }
  }

  return null;
};

/**
 * Find a specific node inside the ReportTreeNode and return it's absolute path as a string.
 * This is just used to display the node's path to the user (uneditable field) to faciliate editing
 * @param _id - id of the node you're looking for
 * @param rootNode - node you're checking
 * @param path - recursive path.
 */
export const returnNodePath = (_id: string, rootNode: IReportTreeNode, path?: string): string | null => {
  if (!rootNode || !_id) {
    return null;
  }
  const inputPath = path ?? "/";
  for (const node of rootNode.children) {
    if (node._id === _id) {
      // Return this path
      return inputPath + node.name + "/";
    } else {
      // Keep recursively searching Tree.
      const deeperPath = inputPath + node.name + "/";
      const pathFound = returnNodePath(_id, node, deeperPath);
      if (pathFound) {
        return pathFound;
      }
    }
  }

  return null;
};

const updateRootReportNode = (reportNodes: IReportTreeNode[]): IReportTreeNode => {
  const root = initializeReportNode([]);
  root.children = [...reportNodes];
  return root;
};

export const ReportingReducer = (
  state: IReportingState = initialState,
  action: ReportingActions.Action
): IReportingState => {
  switch (action.type) {
    case ReportingActions.Type.UPDATE_ACTIVE_PATH:
      return { ...state, path: action.path /*, activeNode: findActiveNode(action.path, state.rootReportNode)*/ };
    case ReportingActions.Type.SET_REPORT_NODES: {
      const rootReportNode = updateRootReportNode(action.reportNodes);
      return { ...state, rootReportNode };
    }
    default:
      return state;
  }
};
